import { initI18n } from '@quadralize/i18n'
import { createSentryErrorHandlers } from '@quadralize/sentry'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { Providers } from '@/app/providers/providers'
import { router } from '@/app/routes/router'
import { initSentry } from '@/config/sentry'
import { initializeZodErrorMap } from '@/config/zod-error-map'
import auth from '@/locales/pt-BR/auth'
import companies from '@/locales/pt-BR/companies'
import dashboard from '@/locales/pt-BR/dashboard'
import error from '@/locales/pt-BR/error'
import layout from '@/locales/pt-BR/layout'
import origins from '@/locales/pt-BR/origins'
import users from '@/locales/pt-BR/users'

import '@/styles/index.css'

initSentry()
initializeZodErrorMap()

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Failed to find the root element')
}

const appRootElement = rootElement

async function bootstrap() {
  await initI18n({
    auth,
    companies,
    dashboard,
    error,
    layout,
    origins,
    users,
  })

  createRoot(appRootElement, createSentryErrorHandlers()).render(
    <StrictMode>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </StrictMode>,
  )
}

void bootstrap()
